import React, { Component, Fragment, Suspense } from "react";
import { Switch, Route } from "react-router-dom";


const Iosguide = React.lazy(() => import('../pages/Iosguide'));
const Iosjsq = React.lazy(() => import('../pages/Iosguide/Iosjsq'));
const Iosrepair = React.lazy(() => import('../pages/Iosguide/Iosrepair'));

const XhnIosPro = React.lazy(() => import('../pages/Iosc26/Xhn_ios_pro'));

const Iosguide2 = React.lazy(() => import('../pages/IosDownload'));
const Iosjsq2 = React.lazy(() => import('../pages/IosDownload/Iosjsq'));
const Iosrepair2 = React.lazy(() => import('../pages/IosDownload/Iosrepair'));

const Iosguide26 = React.lazy(() => import('../pages/Iosc26'));
const Iosjsq26 = React.lazy(() => import('../pages/Iosc26/Iosjsq'));
const Iosrepair26 = React.lazy(() => import('../pages/Iosc26/Iosrepair'));


const macload = React.lazy(() => import('../pages/macload'));
const macload122 = React.lazy(() => import('../pages/macload/Macload'));
const macloadnew = React.lazy(() => import('../pages/macload/Macloadnew'));

const Tuitef = React.lazy(() => import('../pages/Tuite/Tuitef'));

const Invite = React.lazy(() => import("../pages/Invite"));

const ProtocolPrivate = React.lazy(() => import("../pages/Protocol/Private"));
const ProtocolService = React.lazy(() => import("../pages/Protocol/Service"));

const Login = React.lazy(() => import('../pages/Login'));
const Register = React.lazy(() => import('../pages/Login/register'));
const Forgetpassword = React.lazy(() => import('../pages/Login/Forgetpassword'));
const Nodes = React.lazy(() => import('../pages/VpnNodes/Nodes'));
const Tovip = React.lazy(() => import('../pages/VpnNodes/Tovip'));
const Download = React.lazy(() => import('../pages/VpnNodes/Download'));
const Personal = React.lazy(() => import('../pages/VpnNodes/Personal'));

const Pay = React.lazy(() => import('../pages/VpnNodes/Pay'));


const Loading = () => {
  return (
    <Fragment>
    </Fragment>
  )
}

class Router extends Component {
  render() {
    return (
      <Switch>
        <Suspense fallback={<Loading />}>
        {/**登录 */}
        <Route path="/login" component={Login} />
        {/**注册 */}
        <Route path="/register" component={Register} />
        {/**忘记密码 */}
        <Route path="/notpass" component={Forgetpassword} />
        {/**节点 */}
        <Route path="/nodes" component={Nodes} />
        {/**由苹果app跳转过来的支付 */}
        <Route path="/pay" component={Pay} />
        {/**套餐页面 */}
        <Route path="/tovip" component={Tovip} />
        {/**应用下载页面 */}
        <Route path="/download" component={Download} />
        {/**个人中心 */}
        <Route path="/personal" component={Personal} />

        {/* 加速器h5 邀请好友落地页 */}
        <Route path="/invite" component={Invite} />
        {/*mac下载引导页  20221009改为只显示python3*/}
        <Route path="/macload" component={macloadnew} />
        {/*<Route path="/macload" component={macload} />
        <Route path="/macload122" component={macload122} />
        <Route path="/macloadnew" component={macloadnew} />*/}
        {/*<Route path="/macload" component={macload122} />*/}
        {/* 小黑牛IOS下载官方引导页 */}
        <Route path="/iosguide" component={XhnIosPro} />
        <Route path="/xhn_ios_store" component={Iosguide} />
        {/*<Route path="/iosguide" component={Iosguide} />*/}
        {/* IOS下载引导说明 */}
        <Route path="/iosjsq" component={Iosjsq} />
        {/* IOS下载修复说明 */}
        <Route path="/iosrepair" component={Iosrepair} />
        {/* 官网IOS下载引导页 */}
        <Route path="/iosguide2" component={Iosguide2} />
        {/* 官网IOS下载引导说明 */}
        <Route path="/iosjsq2" component={Iosjsq2} />
        {/* 官网IOS下载修复说明 */}
        <Route path="/iosrepair2" component={Iosrepair2} />
        {/* 百度推广IOS下载引导页 */}
        <Route path="/iosguide26" component={Iosguide26} />
        {/* 百度推广IOS下载引导说明 */}
        <Route path="/iosjsq26" component={Iosjsq26} />
        {/* 百度推广IOS下载修复说明 */}
        <Route path="/iosrepair26" component={Iosrepair26} />

        {/* 协议 隐私政策 */}
        <Route path="/protocol-private" component={ProtocolPrivate} />
        <Route path="/protocol-service" component={ProtocolService} />

        {/**默认落地页首页 */}
        {/*<Route exact={true} path="/" component={Login} />*/}

        {/* <Route path="*" component={NotFound}/> */}
        </Suspense>
      </Switch>
    );
  }
}

export default Router;
